import React from "react";
import {
  Heading,
  Text,
  Box,
  Divider,
  UnorderedList,
  ListItem,
  Link,
} from "@chakra-ui/react";

export const PrivacyPolicy = () => (
  <>
    <Box mb="8">
      <Heading as="h1" mb="28">
        Privacy Policy of <strong>Basilium</strong>
      </Heading>
      <Text mb="2">Basilium collects some Personal Data from its Users.</Text>
      <br />
      <Text mb="2">
        This document can be printed for reference by using the print command in
        the settings of any browser.
      </Text>
    </Box>
    <Divider />
    <Box my="8">
      <Heading as="h2" size="md" mb="4">
        {" "}
        Owner and Data Controller{" "}
      </Heading>
      <Text mb="2">
        Daniel Daukševič <br />
        Ukmergės str. 306, Vilnius, Lithuania
      </Text>
      <Text mb="2">
        <strong>Owner contact email:</strong> legal@basilium.app
      </Text>
    </Box>
    <Divider />
    <Box my="8">
      <Heading as="h2" size="md" mb="4">
        {" "}
        Types of Data collected{" "}
      </Heading>
      <Text mb="2">
        {" "}
        Among the types of Personal Data that Basilium collects, by itself or
        through third parties, there are: User ID; Tracker; email address;
        password; Usage Data; various types of Data.{" "}
      </Text>
      <Text mb="2">
        Complete details on each type of Personal Data collected are provided in
        the dedicated sections of this privacy policy or by specific explanation
        texts displayed prior to the Data collection.
        <br />
        Personal Data may be freely provided by the User, or, in case of Usage
        Data, collected automatically when using Basilium.
        <br />
        Unless specified otherwise, all Data requested by Basilium is mandatory
        and failure to provide this Data may make it impossible for Basilium to
        provide its services. In cases where Basilium specifically states that
        some Data is not mandatory, Users are free not to communicate this Data
        without consequences to the availability or the functioning of the
        Service.
        <br />
        Users who are uncertain about which Personal Data is mandatory are
        welcome to contact the Owner.
        <br />
        Any use of Cookies – or of other tracking tools – by Basilium or by the
        owners of third-party services used by Basilium serves the purpose of
        providing the Service required by the User, in addition to any other
        purposes described in the present document and in the Cookie Policy, if
        available.
      </Text>
      <Text mb="2">
        Users are responsible for any third-party Personal Data obtained,
        published or shared through Basilium and confirm that they have the
        third party's consent to provide the Data to the Owner.
      </Text>
    </Box>
    <Divider />
    <Box my="8">
      <Heading as="h2" size="md" mb="4">
        Mode and place of processing the Data
      </Heading>
      <Heading as="h3" size="sm" mb="4" mt="8">
        Methods of processing{" "}
      </Heading>
      <Text mb="2">
        The Owner takes appropriate security measures to prevent unauthorized
        access, disclosure, modification, or unauthorized destruction of the
        Data.
        <br />
        The Data processing is carried out using computers and/or IT enabled
        tools, following organizational procedures and modes strictly related to
        the purposes indicated. In addition to the Owner, in some cases, the
        Data may be accessible to certain types of persons in charge, involved
        with the operation of Basilium (administration, sales, marketing, legal,
        system administration) or external parties (such as third-party
        technical service providers, mail carriers, hosting providers, IT
        companies, communications agencies) appointed, if necessary, as Data
        Processors by the Owner. The updated list of these parties may be
        requested from the Owner at any time.
      </Text>
      <Heading as="h3" size="sm" mb="4" mt="8">
        Legal basis of processing{" "}
      </Heading>
      <Text mb="2">
        The Owner may process Personal Data relating to Users if one of the
        following applies:
      </Text>
      <UnorderedList>
        <ListItem>
          Users have given their consent for one or more specific purposes.
          Note: Under some legislations the Owner may be allowed to process
          Personal Data until the User objects to such processing (“opt-out”),
          without having to rely on consent or any other of the following legal
          bases. This, however, does not apply, whenever the processing of
          Personal Data is subject to European data protection law;
        </ListItem>
        <ListItem>
          provision of Data is necessary for the performance of an agreement
          with the User and/or for any pre-contractual obligations thereof;
        </ListItem>
        <ListItem>
          processing is necessary for compliance with a legal obligation to
          which the Owner is subject;
        </ListItem>
        <ListItem>
          processing is related to a task that is carried out in the public
          interest or in the exercise of official authority vested in the Owner;
        </ListItem>
        <ListItem>
          processing is necessary for the purposes of the legitimate interests
          pursued by the Owner or by a third party.
        </ListItem>
      </UnorderedList>
      <Text mb="2">
        In any case, the Owner will gladly help to clarify the specific legal
        basis that applies to the processing, and in particular whether the
        provision of Personal Data is a statutory or contractual requirement, or
        a requirement necessary to enter into a contract.{" "}
      </Text>
      <Heading as="h3" size="sm" mb="4" mt="8">
        Place{" "}
      </Heading>
      <Text mb="2">
        The Data is processed at the Owner's operating offices and in any other
        places where the parties involved in the processing are located.
        <br />
        <br /> Depending on the User's location, data transfers may involve
        transferring the User's Data to a country other than their own. To find
        out more about the place of processing of such transferred Data, Users
        can check the section containing details about the processing of
        Personal Data.
      </Text>
      <Text mb="2">
        Users are also entitled to learn about the legal basis of Data transfers
        to a country outside the European Union or to any international
        organization governed by public international law or set up by two or
        more countries, such as the UN, and about the security measures taken by
        the Owner to safeguard their Data.
        <br />
        <br /> If any such transfer takes place, Users can find out more by
        checking the relevant sections of this document or inquire with the
        Owner using the information provided in the contact section.
      </Text>
      <Heading as="h3" size="sm" mb="4" mt="8">
        Retention time{" "}
      </Heading>
      <Text mb="2">
        Personal Data shall be processed and stored for as long as required by
        the purpose they have been collected for.
      </Text>
      <Text mb="2">Therefore:</Text>
      <UnorderedList>
        <ListItem>
          Personal Data collected for purposes related to the performance of a
          contract between the Owner and the User shall be retained until such
          contract has been fully performed.
        </ListItem>
        <ListItem>
          Personal Data collected for the purposes of the Owner’s legitimate
          interests shall be retained as long as needed to fulfill such
          purposes. Users may find specific information regarding the legitimate
          interests pursued by the Owner within the relevant sections of this
          document or by contacting the Owner.
        </ListItem>
      </UnorderedList>
      <Text mb="2">
        The Owner may be allowed to retain Personal Data for a longer period
        whenever the User has given consent to such processing, as long as such
        consent is not withdrawn. Furthermore, the Owner may be obliged to
        retain Personal Data for a longer period whenever required to do so for
        the performance of a legal obligation or upon order of an authority.
        <br />
        <br /> Once the retention period expires, Personal Data shall be
        deleted. Therefore, the right of access, the right to erasure, the right
        to rectification and the right to data portability cannot be enforced
        after expiration of the retention period.
      </Text>
    </Box>
    <Divider />
    <Box my="8">
      <Heading as="h2" size="md" mb="4">
        The purposes of processing
      </Heading>
      <Text mb="2">
        The Data concerning the User is collected to allow the Owner to provide
        its Service, comply with its legal obligations, respond to enforcement
        requests, protect its rights and interests (or those of its Users or
        third parties), detect any malicious or fraudulent activity, as well as
        the following: Handling payments, Registration and authentication,
        Registration and authentication provided directly by Basilium, Managing
        contacts and sending messages, Infrastructure monitoring, Hosting and
        backend infrastructure and Platform services and hosting.
      </Text>
      <Text mb="2">
        For specific information about the Personal Data used for each purpose,
        the User may refer to the section “Detailed information on the
        processing of Personal Data”.
      </Text>
    </Box>
    <Box my="8"></Box>
    <Divider />
    <Box my="8">
      <Heading as="h2" size="md" mb="4">
        Detailed information on the processing of Personal Data
      </Heading>
      <Text mb="2">
        Personal Data is collected for the following purposes and using the
        following services:
      </Text>
      <UnorderedList>
        <ListItem>
          <Box my="8">
            <Heading as="h3" size="sm" mb="4" mt="8">
              Handling payments{" "}
            </Heading>
            <Box my="8">
              <Text mb="2">
                Unless otherwise specified, Basilium processes any payments by
                credit card, bank transfer or other means via external payment
                service providers. In general and unless where otherwise stated,
                Users are requested to provide their payment details and
                personal information directly to such payment service providers.
                Basilium isn't involved in the collection and processing of such
                information: instead, it will only receive a notification by the
                relevant payment service provider as to whether payment has been
                successfully completed.
              </Text>
              <Heading as="h4" size="xs" mb="4" mt="8">
                RevenueCat (RevenueCat, Inc.){" "}
              </Heading>
              <Box my="8">
                <Text mb="2">
                  RevenueCat is a payment service provided by RevenueCat, Inc.
                  The service allows the Owner to monitor and analyze the User
                  and their purchase history and can be used to keep track of
                  User behavior.
                </Text>
              </Box>
              <Text mb="2">Personal Data processed: User ID.</Text>
              <Text mb="2">
                Place of processing: United States &ndash;{" "}
                <Link
                  color="blue.500"
                  _hover={{
                    color: "blue.300",
                  }}
                  href="https://www.revenuecat.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </Link>{" "}
                &ndash;{" "}
                <Link
                  color="blue.500"
                  _hover={{
                    color: "blue.300",
                  }}
                  href="mailto:mailtocompliance@revenuecat.com"
                >
                  Opt Out
                </Link>
                .{" "}
              </Text>
            </Box>
          </Box>
        </ListItem>
        <ListItem>
          <Box my="8">
            <Heading as="h3" size="sm" mb="4" mt="8">
              Hosting and backend infrastructure{" "}
            </Heading>
            <Box my="8">
              <Text mb="2">
                This type of service has the purpose of hosting Data and files
                that enable Basilium to run and be distributed as well as to
                provide a ready-made infrastructure to run specific features or
                parts of Basilium.
              </Text>
              <Text mb="2">
                Some services among those listed below, if any, may work through
                geographically distributed servers, making it difficult to
                determine the actual location where the Personal Data are
                stored.
              </Text>
              <Heading as="h4" size="xs" mb="4" mt="8">
                Heroku (Salesforce.com, inc.){" "}
              </Heading>
              <Box my="8">
                <Text mb="2">
                  Heroku is a hosting service provided by Salesforce.com, inc.
                </Text>
              </Box>
              <Text mb="2">
                Personal Data processed: various types of Data as specified in
                the privacy policy of the service.
              </Text>
              <Text mb="2">
                Place of processing: United States &ndash;{" "}
                <Link
                  color="blue.500"
                  _hover={{
                    color: "blue.300",
                  }}
                  href="https://www.salesforce.com/company/privacy/full_privacy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </Link>
                .{" "}
              </Text>
              <Heading as="h4" size="xs" mb="4" mt="8">
                Amazon Web Services (AWS) (Amazon Web Services, Inc.){" "}
              </Heading>
              <Box my="8">
                <Text mb="2">
                  Amazon Web Services (AWS) is a hosting and backend service
                  provided by Amazon Web Services, Inc.
                </Text>
              </Box>
              <Text mb="2">
                Personal Data processed: various types of Data as specified in
                the privacy policy of the service.
              </Text>
              <Text mb="2">
                Place of processing: Ireland &ndash;{" "}
                <Link
                  color="blue.500"
                  _hover={{
                    color: "blue.300",
                  }}
                  href="https://aws.amazon.com/compliance/data-privacy-faq/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </Link>
                .{" "}
              </Text>
            </Box>
          </Box>
        </ListItem>
        <ListItem>
          <Box my="8">
            <Heading as="h3" size="sm" mb="4" mt="8">
              Infrastructure monitoring{" "}
            </Heading>
            <Box my="8">
              <Text mb="2">
                This type of service allows Basilium to monitor the use and
                behavior of its components so its performance, operation,
                maintenance and troubleshooting can be improved.
                <br /> Which Personal Data are processed depends on the
                characteristics and mode of implementation of these services,
                whose function is to filter the activities of Basilium.
              </Text>
              <Heading as="h4" size="xs" mb="4" mt="8">
                Sentry (Functional Software, Inc. ){" "}
              </Heading>
              <Box my="8">
                <Text mb="2">
                  Sentry is a monitoring service provided by Functional
                  Software, Inc. .
                </Text>
              </Box>
              <Text mb="2">
                Personal Data processed: various types of Data as specified in
                the privacy policy of the service.
              </Text>
              <Text mb="2">
                Place of processing: United States &ndash;{" "}
                <Link
                  color="blue.500"
                  _hover={{
                    color: "blue.300",
                  }}
                  href="https://sentry.io/privacy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </Link>
                .{" "}
              </Text>
              <Heading as="h4" size="xs" mb="4" mt="8">
                Coralogix{" "}
              </Heading>
              <Box my="8">
                <Text mb="2">
                  Coralogix is a log monitoring service provided by Coralogix
                  LTD.
                  <br />
                  <br />
                  Personal Data processed: UserId
                </Text>
              </Box>
              <Heading as="h4" size="xs" mb="4" mt="8">
                PagerDuty{" "}
              </Heading>
              <Box my="8">
                <Text mb="2">
                  PagerDuty is an incident response platform provided by
                  PagerDuty, Inc.
                  <br />
                  <br />
                  Personal Data processed: UserId
                </Text>
              </Box>
            </Box>
          </Box>
        </ListItem>
        <ListItem>
          <Box my="8">
            <Heading as="h3" size="sm" mb="4" mt="8">
              Managing contacts and sending messages{" "}
            </Heading>
            <Box my="8">
              <Text mb="2">
                This type of service makes it possible to manage a database of
                email contacts, phone contacts or any other contact information
                to communicate with the User.
                <br /> These services may also collect data concerning the date
                and time when the message was viewed by the User, as well as
                when the User interacted with it, such as by clicking on links
                included in the message.
              </Text>
              <Heading as="h4" size="xs" mb="4" mt="8">
                Amazon Simple Email Service (Amazon){" "}
              </Heading>
              <Box my="8">
                <Text mb="2">
                  Amazon Simple Email Service is an email address management and
                  message sending service provided by Amazon.com Inc.
                </Text>
              </Box>
              <Text mb="2">Personal Data processed: email address.</Text>
              <Text mb="2">
                Place of processing: United States &ndash;{" "}
                <Link
                  color="blue.500"
                  _hover={{
                    color: "blue.300",
                  }}
                  href="https://aws.amazon.com/compliance/data-privacy-faq/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </Link>
                .{" "}
              </Text>
            </Box>
          </Box>
        </ListItem>
        <ListItem>
          <Box my="8">
            <Heading as="h3" size="sm" mb="4" mt="8">
              Platform services and hosting{" "}
            </Heading>
            <Box my="8">
              <Text mb="2">
                These services have the purpose of hosting and running key
                components of Basilium, therefore allowing the provision of
                Basilium from within a unified platform. Such platforms provide
                a wide range of tools to the Owner – e.g. analytics, user
                registration, commenting, database management, e-commerce,
                payment processing – that imply the collection and handling of
                Personal Data. <br /> Some of these services work through
                geographically distributed servers, making it difficult to
                determine the actual location where the Personal Data are
                stored.
              </Text>
              <Heading as="h4" size="xs" mb="4" mt="8">
                Google Play Store (Google LLC){" "}
              </Heading>
              <Box my="8">
                <Text mb="2">
                  Basilium is distributed on the Google Play Store, a platform
                  for the distribution of mobile apps, provided by Google LLC.
                </Text>
                <Text mb="2">
                  By virtue of being distributed via this app store, Google
                  collects usage and diagnostics data and share aggregate
                  information with the Owner. Much of this information is
                  processed on an opt-in basis.
                </Text>
                <Text mb="2">
                  Users may opt-out of this analytics feature directly through
                  their device settings. More information on how to manage
                  analysis settings can be found on{" "}
                  <Link
                    color="blue.500"
                    _hover={{
                      color: "blue.300",
                    }}
                    href="https://support.google.com/accounts/answer/6078260"
                  >
                    this page
                  </Link>
                  .
                </Text>
              </Box>
              <Text mb="2">Personal Data processed: Usage Data.</Text>
              <Text mb="2">
                Place of processing: United States &ndash;{" "}
                <Link
                  color="blue.500"
                  _hover={{
                    color: "blue.300",
                  }}
                  href="https://policies.google.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </Link>
                .{" "}
              </Text>
              <Text mb="2">Personal Data processed: Usage Data.</Text>
              <Text mb="2">
                Place of processing: United States &ndash;{" "}
                <Link
                  color="blue.500"
                  _hover={{
                    color: "blue.300",
                  }}
                  href="https://www.apple.com/legal/privacy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </Link>
                .{" "}
              </Text>
            </Box>
          </Box>
        </ListItem>
        <ListItem>
          <Box my="8">
            <Heading as="h3" size="sm" mb="4" mt="8">
              Registration and authentication provided directly by Basilium
            </Heading>
            <Box my="8">
              <Text mb="2">
                By registering or authenticating, Users allow Basilium to
                identify them and give them access to dedicated services. The
                Personal Data is collected and stored for registration or
                identification purposes only. The Data collected are only those
                necessary for the provision of the service requested by the
                Users.
              </Text>
              <Heading as="h4" size="xs" mb="4" mt="8">
                Direct registration (Basilium){" "}
              </Heading>
              <Box my="8">
                <Text mb="2">
                  The User registers by filling out the registration form and
                  providing the Personal Data directly to Basilium.
                </Text>
              </Box>
              <Text mb="2">
                Personal Data processed: email address; password.
              </Text>
            </Box>
          </Box>
        </ListItem>
      </UnorderedList>
    </Box>
    <Box my="8"></Box>
    <Divider />
    <Box my="8">
      <Heading as="h2" size="md" mb="4">
        Further information about the processing of Personal Data
      </Heading>
      <UnorderedList>
        <ListItem>
          <Box my="8">
            <Heading as="h3" size="sm" mb="4" mt="8">
              Equal protection of User Data{" "}
            </Heading>
            <Box my="8">
              <Box my="8">
                <Text mb="2">
                  Basilium shares User Data only with third parties carefully
                  selected to ensure that they provide the same or equal
                  protection of User Data as stated in this privacy policy and
                  requested by applicable data protection laws. Further
                  information on data processing and privacy practices by third
                  parties can be found in their respective privacy policies.
                </Text>
              </Box>
            </Box>
          </Box>
        </ListItem>
      </UnorderedList>
    </Box>
    <Box my="8">
      <Heading as="h2" size="md" mb="4">
        The rights of Users
      </Heading>
      <Text mb="2">
        Users may exercise certain rights regarding their Data processed by the
        Owner.
      </Text>
      <Text mb="2">
        In particular, Users have the right to do the following:
      </Text>
      <UnorderedList>
        <ListItem>
          <strong>Withdraw their consent at any time.</strong> Users have the
          right to withdraw consent where they have previously given their
          consent to the processing of their Personal Data.
        </ListItem>
        <ListItem>
          <strong>Object to processing of their Data.</strong> Users have the
          right to object to the processing of their Data if the processing is
          carried out on a legal basis other than consent. Further details are
          provided in the dedicated section below.
        </ListItem>
        <ListItem>
          <strong>Access their Data.</strong> Users have the right to learn if
          Data is being processed by the Owner, obtain disclosure regarding
          certain aspects of the processing and obtain a copy of the Data
          undergoing processing.
        </ListItem>
        <ListItem>
          <strong>Verify and seek rectification.</strong> Users have the right
          to verify the accuracy of their Data and ask for it to be updated or
          corrected.
        </ListItem>
        <ListItem>
          <strong>Restrict the processing of their Data.</strong> Users have the
          right, under certain circumstances, to restrict the processing of
          their Data. In this case, the Owner will not process their Data for
          any purpose other than storing it.{" "}
        </ListItem>
        <ListItem>
          <strong>
            Have their Personal Data deleted or otherwise removed.
          </strong>{" "}
          Users have the right, under certain circumstances, to obtain the
          erasure of their Data from the Owner.
        </ListItem>
        <ListItem>
          <strong>
            Receive their Data and have it transferred to another controller.
          </strong>{" "}
          Users have the right to receive their Data in a structured, commonly
          used and machine readable format and, if technically feasible, to have
          it transmitted to another controller without any hindrance. This
          provision is applicable provided that the Data is processed by
          automated means and that the processing is based on the User's
          consent, on a contract which the User is part of or on pre-contractual
          obligations thereof.
        </ListItem>
        <ListItem>
          <strong>Lodge a complaint.</strong> Users have the right to bring a
          claim before their competent data protection authority.
        </ListItem>
      </UnorderedList>
      <Heading as="h3" size="sm" mb="4" mt="8">
        Details about the right to object to processing{" "}
      </Heading>
      <Text mb="2">
        Where Personal Data is processed for a public interest, in the exercise
        of an official authority vested in the Owner or for the purposes of the
        legitimate interests pursued by the Owner, Users may object to such
        processing by providing a ground related to their particular situation
        to justify the objection.
      </Text>
      <Text mb="2">
        Users must know that, however, should their Personal Data be processed
        for direct marketing purposes, they can object to that processing at any
        time without providing any justification. To learn, whether the Owner is
        processing Personal Data for direct marketing purposes, Users may refer
        to the relevant sections of this document.{" "}
      </Text>
      <Heading as="h3" size="sm" mb="4" mt="8">
        How to exercise these rights{" "}
      </Heading>
      <Text mb="2">
        Any requests to exercise User rights can be directed to the Owner
        through the contact details provided in this document. These requests
        can be exercised free of charge and will be addressed by the Owner as
        early as possible and always within one month.
      </Text>
    </Box>
    <Divider />
    <Box my="8">
      <Heading as="h2" size="md" mb="4">
        Additional information about Data collection and processing
      </Heading>
      <Heading as="h3" size="sm" mb="4" mt="8">
        Legal action{" "}
      </Heading>
      <Text mb="2">
        The User's Personal Data may be used for legal purposes by the Owner in
        Court or in the stages leading to possible legal action arising from
        improper use of Basilium or the related Services.
        <br />
        The User declares to be aware that the Owner may be required to reveal
        personal data upon request of public authorities.
      </Text>
      <Heading as="h3" size="sm" mb="4" mt="8">
        Additional information about User's Personal Data{" "}
      </Heading>
      <Text mb="2">
        In addition to the information contained in this privacy policy,
        Basilium may provide the User with additional and contextual information
        concerning particular Services or the collection and processing of
        Personal Data upon request.
      </Text>
      <Heading as="h3" size="sm" mb="4" mt="8">
        System logs and maintenance{" "}
      </Heading>
      <Text mb="2">
        For operation and maintenance purposes, Basilium and any third-party
        services may collect files that record interaction with Basilium (System
        logs) use other Personal Data (such as the IP Address) for this purpose.
      </Text>
      <Heading as="h3" size="sm" mb="4" mt="8">
        Information not contained in this policy{" "}
      </Heading>
      <Text mb="2">
        More details concerning the collection or processing of Personal Data
        may be requested from the Owner at any time. Please see the contact
        information at the beginning of this document.
      </Text>
      <Heading as="h3" size="sm" mb="4" mt="8">
        How “Do Not Track” requests are handled{" "}
      </Heading>
      <Text mb="2">
        Basilium does not support “Do Not Track” requests.
        <br />
        To determine whether any of the third-party services it uses honor the
        “Do Not Track” requests, please read their privacy policies.
      </Text>
      <Heading as="h3" size="sm" mb="4" mt="8">
        Changes to this privacy policy{" "}
      </Heading>
      <Text mb="2">
        The Owner reserves the right to make changes to this privacy policy at
        any time by notifying its Users on this page and possibly within
        Basilium and/or - as far as technically and legally feasible - sending a
        notice to Users via any contact information available to the Owner. It
        is strongly recommended to check this page often, referring to the date
        of the last modification listed at the bottom. <br />
        <br /> Should the changes affect processing activities performed on the
        basis of the User’s consent, the Owner shall collect new consent from
        the User, where required.
      </Text>
    </Box>
    <Divider />
    <Box my="8" borderWidth="thin">
      <Heading as="h3" size="sm" borderBottomWidth="thin" p="4">
        Definitions and legal references
      </Heading>
      <Box my="8" px="4">
        <Heading as="h4" size="xs" mb="4" mt="8">
          Personal Data (or Data){" "}
        </Heading>
        <Text mb="2">
          Any information that directly, indirectly, or in connection with other
          information — including a personal identification number — allows for
          the identification or identifiability of a natural person.
        </Text>
        <Heading as="h4" size="xs" mb="4" mt="8">
          Usage Data
        </Heading>
        <Text mb="2">
          Information collected automatically through Basilium (or third-party
          services employed in Basilium), which can include: the IP addresses or
          domain names of the computers utilized by the Users who use Basilium,
          the URI addresses (Uniform Resource Identifier), the time of the
          request, the method utilized to submit the request to the server, the
          size of the file received in response, the numerical code indicating
          the status of the server's answer (successful outcome, error, etc.),
          the country of origin, the features of the browser and the operating
          system utilized by the User, the various time details per visit (e.g.,
          the time spent on each page within the Application) and the details
          about the path followed within the Application with special reference
          to the sequence of pages visited, and other parameters about the
          device operating system and/or the User's IT environment.
        </Text>
        <Heading as="h4" size="xs" mb="4" mt="8">
          User{" "}
        </Heading>
        <Text mb="2">
          The individual using Basilium who, unless otherwise specified,
          coincides with the Data Subject.
        </Text>
        <Heading as="h4" size="xs" mb="4" mt="8">
          Data Subject{" "}
        </Heading>
        <Text mb="2">The natural person to whom the Personal Data refers.</Text>
        <Heading as="h4" size="xs" mb="4" mt="8">
          Data Processor (or Data Supervisor){" "}
        </Heading>
        <Text mb="2">
          The natural or legal person, public authority, agency or other body
          which processes Personal Data on behalf of the Controller, as
          described in this privacy policy.
        </Text>
        <Heading as="h4" size="xs" mb="4" mt="8">
          Data Controller (or Owner){" "}
        </Heading>
        <Text mb="2">
          The natural or legal person, public authority, agency or other body
          which, alone or jointly with others, determines the purposes and means
          of the processing of Personal Data, including the security measures
          concerning the operation and use of Basilium. The Data Controller,
          unless otherwise specified, is the Owner of Basilium.
        </Text>
        <Heading as="h4" size="xs" mb="4" mt="8">
          Basilium (or this Application){" "}
        </Heading>
        <Text mb="2">
          The means by which the Personal Data of the User is collected and
          processed.
        </Text>
        <Heading as="h4" size="xs" mb="4" mt="8">
          Service{" "}
        </Heading>
        <Text mb="2">
          The service provided by Basilium as described in the relative terms
          (if available) and on this site/application.
        </Text>
        <Heading as="h4" size="xs" mb="4" mt="8">
          European Union (or EU){" "}
        </Heading>
        <Text mb="2">
          Unless otherwise specified, all references made within this document
          to the European Union include all current member states to the
          European Union and the European Economic Area.
        </Text>
        <Heading as="h4" size="xs" mb="4" mt="8">
          Cookie{" "}
        </Heading>
        <Text mb="2">
          Cookies are Trackers consisting of small sets of data stored in the
          User&#39;s browser.
        </Text>
        <Heading as="h4" size="xs" mb="4" mt="8">
          Tracker{" "}
        </Heading>
        <Text mb="2">
          Tracker indicates any technology - e.g Cookies, unique identifiers,
          web beacons, embedded scripts, e-tags and fingerprinting - that
          enables the tracking of Users, for example by accessing or storing
          information on the User’s device.
        </Text>
        <hr />
        <Heading as="h4" size="xs" mb="4" mt="8">
          Legal information{" "}
        </Heading>
        <Text mb="2">
          This privacy statement has been prepared based on provisions of
          multiple legislations, including Art. 13/14 of Regulation (EU)
          2016/679 (General Data Protection Regulation).
        </Text>
        <Text mb="2">
          This privacy policy relates solely to Basilium, if not stated
          otherwise within this document.
        </Text>
      </Box>
    </Box>
    <Box my="8">
      <Text mb="2"> Latest update: August 13, 2023 </Text>
    </Box>
  </>
);
